export default __webpack_public_path__ + "745f3928d9854822d08a6181cc5c7e8d.ttf";